import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InfoService } from '../info.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
  providers: [ InfoService ]
})
export class ImprintComponent extends BaseComponent implements OnInit {

  @ViewChild("header", {static: false}) header;

  constructor(private infoService: InfoService) {
    super();
  }

  ngOnInit() {
    
  }

}
